import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';

class Export extends React.Component {
    onClick = () => {
        const { start, end, organizationId, onDownloadReport } = this.props;
        onDownloadReport({ start, end, organizationId });
    };
    render() {
        const { loading } = this.props;
        if (loading) {
            return null;
        }
        return (
            <Tooltip title="Download CSV">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onClick}
                >
                    EXPORT
                </Button>
            </Tooltip>
        );
    }
}

Export.propTypes = {
    start: PropTypes.string,
    end: PropTypes.string,
    organizationId: PropTypes.number.isRequired,
    onDownloadReport: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

Export.defaultProps = {
    start: undefined,
    end: undefined,
};

export default Export;



// WEBPACK FOOTER //
// ./src/components/report/Export.js